import { MomentTemplateStatus } from '@dadohr/shared/domainTypes/experience';
import { capitalize } from 'lodash';
import { ColoredChipLight } from '../../../../components/ColoredChip';
import { UnsafeTFunction, useUnsafeTranslation } from '../../../../i18next';

const getMomentStatus = (status: MomentTemplateStatus, t: UnsafeTFunction) => {
  switch (status) {
    case MomentTemplateStatus.DRAFT:
      return (
        <ColoredChipLight color="gray" size="small">
          {capitalize(t('Draft'))}
        </ColoredChipLight>
      );
    case MomentTemplateStatus.SCHEDULED:
      return (
        <ColoredChipLight color="blue" size="small">
          {capitalize(t('Scheduled'))}
        </ColoredChipLight>
      );
    case MomentTemplateStatus.COMPLETE:
      return (
        <ColoredChipLight color="green" size="small">
          {capitalize(t('Sent'))}
        </ColoredChipLight>
      );
    case MomentTemplateStatus.TEMPLATE:
      return (
        <ColoredChipLight color="purple" size="small">
          {capitalize(t('Template'))}
        </ColoredChipLight>
      );
  }
};

export const MomentTemplateStatusChip = ({
  status
}: {
  status: MomentTemplateStatus;
}) => {
  const { t } = useUnsafeTranslation();
  return getMomentStatus(status, t);
};
